import { ReduceStore } from 'flux/utils';
import Immutable, { Set } from 'immutable';

import AppDispatcher from '../AppDispatcher';
import JobStore from './JobStore';
import CurrentUserStore from './CurrentUserStore';

class JobUsersStore extends ReduceStore {
  getInitialState() {
    return new Set();
  }

  reduce(state) {
    this.getDispatcher().waitFor([
      JobStore.getDispatchToken(),
      CurrentUserStore.getDispatchToken()]);

    if (JobStore.hasChanged() || CurrentUserStore.hasChanged()) {
      const allJobs = JobStore.getAllChrono();
      const allJobUsers = allJobs.map((j) => j.creator).toSet();
      const currentUser = CurrentUserStore.getState();

      if (currentUser != null) {
        return allJobUsers.add(currentUser.email);
      }

      return allJobUsers;
    }

    return state;
  }

  areEqual(one, two) {
    return Immutable.is(one, two);
  }
}

const instance = new JobUsersStore(AppDispatcher);
export default instance;
